module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0123.jpg?v=4603e67d";